import { render } from "./WhereToGoHeroSection.vue?vue&type=template&id=ddd83b06&scoped=true"
import script from "./WhereToGoHeroSection.vue?vue&type=script&lang=js"
export * from "./WhereToGoHeroSection.vue?vue&type=script&lang=js"

import "./WhereToGoHeroSection.vue?vue&type=style&index=0&id=ddd83b06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd83b06"]])

export default __exports__